<template>
  <div>
    <v-footer color="white" padless app class="teacher-bottom-shell">
      <v-bottom-navigation :value="activeTab" color="primary" grow class="teacher-bottom-nav">
        <v-btn value="home" aria-label="Home" @click="home">
          <v-icon>mdi-home-variant-outline</v-icon>
          <span>Home</span>
        </v-btn>

        <v-btn value="attendance" aria-label="Take attendance" @click="openAttendance">
          <v-icon>mdi-account-check-outline</v-icon>
          <span>Attendance</span>
        </v-btn>

        <v-btn value="menu" aria-label="Open more options" @click="drawer = true">
          <v-icon>mdi-view-grid-outline</v-icon>
          <span>More</span>
        </v-btn>
      </v-bottom-navigation>
    </v-footer>

    <v-bottom-sheet v-model="drawer" inset max-width="520" content-class="teacher-more-drawer-wrap">
      <v-card
        class="teacher-more-drawer"
        :class="{ 'teacher-more-drawer--dragging': drawerDragging }"
        :style="drawerDragStyle"
        elevation="0"
      >
        <div
          class="teacher-more-drawer__drag-zone"
          @touchstart="onDrawerTouchStart"
          @touchmove.prevent="onDrawerTouchMove"
          @touchend="onDrawerTouchEnd"
          @touchcancel="resetDrawerDrag"
        >
          <div class="teacher-more-drawer__handle" aria-hidden="true"></div>
          <div class="teacher-more-drawer__header">
            <div>
              <p>Teacher tools</p>
              <h2>More options</h2>
            </div>
            <v-btn icon aria-label="Close menu" @click="drawer = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="teacher-more-drawer__options">
          <button type="button" @click="openReport">
            <span class="teacher-more-drawer__icon teacher-more-drawer__icon--report">
              <v-icon color="#3c6e9c">mdi-chart-box-outline</v-icon>
            </span>
            <span class="teacher-more-drawer__copy">
              <strong>Attendance report</strong>
              <small>Review attendance by student</small>
            </span>
            <v-icon size="20" color="#96a29a">mdi-chevron-right</v-icon>
          </button>

          <button type="button" @click="openGrades">
            <span class="teacher-more-drawer__icon teacher-more-drawer__icon--grades">
              <v-icon color="#8a6525">mdi-school-outline</v-icon>
            </span>
            <span class="teacher-more-drawer__copy">
              <strong>Report cards &amp; grades</strong>
              <small>Enter grades for the current term</small>
            </span>
            <v-icon size="20" color="#96a29a">mdi-chevron-right</v-icon>
          </button>

          <button type="button" @click="openTimeOff">
            <span class="teacher-more-drawer__icon teacher-more-drawer__icon--time-off">
              <v-icon color="#7a4f8f">mdi-calendar-clock-outline</v-icon>
            </span>
            <span class="teacher-more-drawer__copy">
              <strong>Time-off request</strong>
              <small>Submit and track a request</small>
            </span>
            <v-icon size="20" color="#96a29a">mdi-chevron-right</v-icon>
          </button>
        </div>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      drawerDragY: 0,
      drawerDragging: false,
      drawerTouchStartY: 0,
      drawerTouchStartedAt: 0,
    };
  },
  computed: {
    activeTab() {
      if (this.$route.name === "class-room-attendance") return "attendance";
      if (["tools", "class-room-report", "years", "grade-entry", "teacher-time-off"].includes(this.$route.name)) return "menu";
      return "home";
    },
    drawerDragStyle() {
      return { transform: `translateY(${this.drawerDragY}px)` };
    },
  },
  watch: {
    drawer(isOpen) {
      if (!isOpen) this.resetDrawerDrag();
    },
  },
  methods: {
    onDrawerTouchStart(event) {
      if (event.touches.length !== 1) return;
      this.drawerTouchStartY = event.touches[0].clientY;
      this.drawerTouchStartedAt = Date.now();
      this.drawerDragging = true;
    },
    onDrawerTouchMove(event) {
      if (!this.drawerDragging || event.touches.length !== 1) return;
      this.drawerDragY = Math.max(0, event.touches[0].clientY - this.drawerTouchStartY);
    },
    onDrawerTouchEnd() {
      if (!this.drawerDragging) return;
      const elapsed = Math.max(Date.now() - this.drawerTouchStartedAt, 1);
      const velocity = this.drawerDragY / elapsed;
      const shouldClose = this.drawerDragY > 90 || velocity > 0.55;
      this.drawerDragging = false;
      if (shouldClose) {
        this.drawer = false;
        return;
      }
      this.drawerDragY = 0;
    },
    resetDrawerDrag() {
      this.drawerDragging = false;
      this.drawerDragY = 0;
      this.drawerTouchStartY = 0;
      this.drawerTouchStartedAt = 0;
    },
    openAttendance() {
      if (this.$route.name !== "class-room-attendance") {
        this.$router.push({ name: "class-room-attendance" });
      }
    },
    openReport() {
      this.drawer = false;
      if (this.$route.name !== "class-room-report") this.$router.push({ name: "class-room-report" });
    },
    openGrades() {
      this.drawer = false;
      if (this.$route.name !== "years") this.$router.push({ name: "years" });
    },
    openTimeOff() {
      this.drawer = false;
      if (this.$route.name !== "teacher-time-off") this.$router.push({ name: "teacher-time-off" });
    },
    home() {
      if (this.$route.name !== "home") this.$router.push({ path: "/" });
    },
  },
};
</script>
